<ng-container *transloco="let t">
  <div class="race-profile_graph_container">
    <div #raceProfile class="race-profile_graph_wrapper"></div>
  </div>
</ng-container>
